import Icon from '@/components/snippets/icon/icon'

export function FilterCollapse({ label, children, 'data-ui': dataUi }) {
  const id = `filter-${label.toLowerCase().replace(/\s/g, '-')}`
  return (
    <x-modal
      data-id={`filter-${id}`}
      className="dropdown-modal group flex flex-col data-visible:pb-1.5 px-margin border-b border-borders-default transition-all"
      data-toggle-group="true"
      {...(dataUi !== undefined ? { 'data-ui': dataUi } : {})}
    >
      <button
        className="flex items-center justify-between gap-x-0.75 py-1 text-left link-fade"
        data-modal-parent={`filter-${id}`}
        data-modal-role="toggle"
        aria-label={label}
      >
        <span className="paragraph-xs font-heading-spaced uppercase">{label}</span>
        <div className="shrink-0 flex">
          <span className="size-[10px] children:size-full children:object-contain group-data-visible:hidden">
            <Icon id="plus" />
          </span>
          <span className="size-[10px] children:size-full children:object-contain hidden group-data-visible:block">
            <Icon id="minus" />
          </span>
      </div>
      </button>
      <div className="dropdown-content">
        <div className="flex flex-col gap-1.5 pl-px overflow-hidden">{children}</div>
      </div>
    </x-modal>
  )
}
